import * as types from '../../lib/actionTypes.es6'

export function getAllProductsRequest(payload) {
  return {
    type: types.VIEW_ALL_PRODUCTS_REQUEST,
    payload
  }
}

export function getAllProductsFailure(error) {
  return {
    type: types.VIEW_ALL_PRODUCTS_FAILURE,
    payload: error
  }
}

export function getAllProductsSuccess(response) {
  return {
    type: types.VIEW_ALL_PRODUCTS_SUCCESS,
    payload: response
  }
}

export function createProductRequest(payload) {
  return {
    type: types.CREATE_PRODUCT_REQUEST,
    payload
  }
}

export function createProductFailure(error) {
  return {
    type: types.CREATE_PRODUCT_FAILURE,
    payload: error
  }
}

export function createProductSuccess(response) {
  return {
    type: types.CREATE_PRODUCT_SUCCESS,
    payload: response
  }
}

export function resetCreateProductSuccess(error) {
  return {
    type: types.RESET_PRODUCT_SUCCESS
  }
}

export function resetCreateProductError(error) {
  return {
    type: types.RESET_PRODUCT_ERROR
  }
}
export function getProductRequest(payload) {
  return {
    type: types.VIEW_PRODUCT_REQUEST,
    payload
  }
}

export function getProductFailure(error) {
  return {
    type: types.VIEW_PRODUCT_FAILURE,
    payload: error
  }
}

export function getProductSuccess(response) {
  return {
    type: types.VIEW_PRODUCT_SUCCESS,
    payload: response
  }
}

export function getAllPartnersRequest() {
  return {
    type: types.VIEW_ALL_PARTNERS_REQUEST
  }
}

export function getProductEnumsRequest(payload) {
  return {
    type: types.PRODUCT_ENUMS_REQUEST,
    payload
  }
}

export function getProductEnumsFailure(error) {
  return {
    type: types.PRODUCT_ENUMS_FAILURE,
    payload: error
  }
}

export function getProductEnumsSuccess(response) {
  return {
    type: types.PRODUCT_ENUMS_SUCCESS,
    payload: response
  }
}

export function getProductPremiumEnumsRequest(payload) {
  return {
    type: types.PRODUCT_PREMIUM_ENUMS_REQUEST,
    payload
  }
}

export function getProductPremiumsRequest(payload) {
  return {
    type: types.VIEW_ALL_PRODUCT_PREMIUMS_REQUEST,
    payload
  }
}

export function createProductPremiumRequest(payload) {
  return {
    type: types.CREATE_PRODUCT_PREMIUM_REQUEST,
    payload
  }
}

// PREMIUMS
export function createPremiumRequest(payload) {
  return {
    type: types.CREATE_PREMIUM_REQUEST,
    payload
  }
}

export function createPremiumFailure(error) {
  return {
    type: types.CREATE_PREMIUM_FAILURE,
    payload: error
  }
}

export function createPremiumSuccess(response) {
  return {
    type: types.CREATE_PREMIUM_SUCCESS,
    payload: response
  }
}

export function resetCreatePremiumSuccess(error) {
  return {
    type: types.RESET_CREATE_PREMIUM_SUCCESS
  }
}

export function resetCreatePremiumError(error) {
  return {
    type: types.RESET_CREATE_PREMIUM_ERROR
  }
}

export function hardDeletePremiumRequest(payload) {
  return {
    type: types.HARD_DELETE_PREMIUM_REQUEST,
    payload
  }
}

export function hardDeletePremiumFailure(error) {
  return {
    type: types.HARD_DELETE_PREMIUM_FAILURE,
    payload: error
  }
}

export function hardDeletePremiumSuccess(response) {
  return {
    type: types.HARD_DELETE_PREMIUM_SUCCESS,
    payload: response
  }
}

export function resetHardDeletePremiumSuccess(error) {
  return {
    type: types.RESET_HARD_DELETE_PREMIUM_SUCCESS
  }
}

export function resetHardDeletePremiumError(error) {
  return {
    type: types.RESET_HARD_DELETE_PREMIUM_ERROR
  }
}

export function softDeletePremiumRequest(payload) {
  return {
    type: types.SOFT_DELETE_PREMIUM_REQUEST,
    payload
  }
}

export function softDeletePremiumFailure(error) {
  return {
    type: types.SOFT_DELETE_PREMIUM_FAILURE,
    payload: error
  }
}

export function softDeletePremiumSuccess(response) {
  return {
    type: types.SOFT_DELETE_PREMIUM_SUCCESS,
    payload: response
  }
}

export function editPremiumRequest(payload) {
  return {
    type: types.EDIT_PREMIUM_REQUEST,
    payload
  }
}

export function editPremiumFailure(error) {
  return {
    type: types.EDIT_PREMIUM_FAILURE,
    payload: error
  }
}

export function editPremiumSuccess(response) {
  return {
    type: types.EDIT_PREMIUM_SUCCESS,
    payload: response
  }
}

export function resetEditPremiumSuccess(error) {
  return {
    type: types.RESET_EDIT_PREMIUM_SUCCESS
  }
}

export function resetEditPremiumError(error) {
  return {
    type: types.RESET_EDIT_PREMIUM_ERROR
  }
}

// BENEFITS

export function createBenefitRequest(payload) {
  return {
    type: types.CREATE_BENEFIT_REQUEST,
    payload
  }
}

export function createBenefitFailure(error) {
  return {
    type: types.CREATE_BENEFIT_FAILURE,
    payload: error
  }
}

export function createBenefitSuccess(response) {
  return {
    type: types.CREATE_BENEFIT_SUCCESS,
    payload: response
  }
}

export function resetCreateBenefitSuccess(error) {
  return {
    type: types.RESET_CREATE_BENEFIT_SUCCESS
  }
}

export function resetCreateBenefitError(error) {
  return {
    type: types.RESET_CREATE_BENEFIT_ERROR
  }
}
export function resetCreateBenefitsAndPremiumsLists(error) {
  return {
    type: 'RESET_CREATED_BENEFITS_AND_PREMIUMS_LISTS'
  }
}

export function hardDeleteBenefitRequest(payload) {
  return {
    type: types.HARD_DELETE_BENEFIT_REQUEST,
    payload
  }
}

export function hardDeleteBenefitFailure(error) {
  return {
    type: types.HARD_DELETE_BENEFIT_FAILURE,
    payload: error
  }
}

export function hardDeleteBenefitSuccess(response) {
  return {
    type: types.HARD_DELETE_BENEFIT_SUCCESS,
    payload: response
  }
}

export function resetHardDeleteBenefitSuccess(error) {
  return {
    type: types.RESET_HARD_DELETE_BENEFIT_SUCCESS
  }
}

export function resetHardDeleteBenefitError(error) {
  return {
    type: types.RESET_HARD_DELETE_BENEFIT_ERROR
  }
}

export function softDeleteBenefitRequest(payload) {
  return {
    type: types.SOFT_DELETE_BENEFIT_REQUEST,
    payload
  }
}

export function softDeleteBenefitFailure(error) {
  return {
    type: types.SOFT_DELETE_BENEFIT_FAILURE,
    payload: error
  }
}

export function softDeleteBenefitSuccess(response) {
  return {
    type: types.SOFT_DELETE_BENEFIT_SUCCESS,
    payload: response
  }
}

export function editBenefitRequest(payload) {
  return {
    type: types.EDIT_BENEFIT_REQUEST,
    payload
  }
}

export function editBenefitFailure(error) {
  return {
    type: types.EDIT_BENEFIT_FAILURE,
    payload: error
  }
}

export function editBenefitSuccess(response) {
  return {
    type: types.EDIT_BENEFIT_SUCCESS,
    payload: response
  }
}

export function resetEditBenefitSuccess(error) {
  return {
    type: types.RESET_EDIT_BENEFIT_SUCCESS
  }
}

export function resetEditBenefitError(error) {
  return {
    type: types.RESET_EDIT_BENEFIT_ERROR
  }
}

export function updateDialogProductType(response) {
  return {
    type: 'UPDATE_PRODUCT_TYPE_IN_DIALOG',
    payload: response
  }
}

export function editProductRequest(payload) {
  return {
    type: types.EDIT_PRODUCT_REQUEST,
    payload
  }
}

export function editProductFailure(error) {
  return {
    type: types.EDIT_PRODUCT_FAILURE,
    payload: error
  }
}

export function editProductSuccess(response) {
  return {
    type: types.EDIT_PRODUCT_SUCCESS,
    payload: response
  }
}

export function resetEditProductSuccess(error) {
  return {
    type: types.RESET_PRODUCT_SUCCESS
  }
}

export function resetEditProductError(error) {
  return {
    type: types.RESET_PRODUCT_ERROR
  }
}

export function setPremiumToEdit(response) {
  return {
    type: types.SET_PREMIUM_TO_EDIT,
    payload: response
  }
}

export function setPremiumToDelete(response) {
  return {
    type: types.SET_PREMIUM_TO_DELETE,
    payload: response
  }
}

export function setBenefitToEdit(response) {
  return {
    type: types.SET_BENEFIT_TO_EDIT,
    payload: response
  }
}

export function setBenefitToDelete(response) {
  return {
    type: types.SET_BENEFIT_TO_DELETE,
    payload: response
  }
}

export function resetPremiumToEdit(response) {
  return {
    type: types.RESET_PREMIUM_TO_EDIT
  }
}

export function resetPremiumToDelete(response) {
  return {
    type: types.RESET_PREMIUM_TO_DELETE
  }
}

export function resetBenefitToEdit(response) {
  return {
    type: types.RESET_BENEFIT_TO_EDIT
  }
}

export function resetBenefitToDelete(response) {
  return {
    type: types.RESET_BENEFIT_TO_DELETE
  }
}

// GET GROUP_PRODUCT_CONFIGS
export function getGroupProductConfigsRequest(payload) {
  return {
    type: types.GET_GROUP_PRODUCT_CONFIGS_REQUEST,
    payload
  }
}

export function getGroupProductConfigsFailure(error) {
  return {
    type: types.GET_GROUP_PRODUCT_CONFIGS_FAILURE,
    payload: error
  }
}

export function getGroupProductConfigsSuccess(response) {
  return {
    type: types.GET_GROUP_PRODUCT_CONFIGS_SUCCESS,
    payload: response
  }
}

// update GROUP_PRODUCT_CONFIGS
export function updateGroupProductConfigsRequest(payload) {
  return {
    type: types.UPDATE_GROUP_PRODUCT_CONFIGS_REQUEST,
    payload
  }
}

export function updateGroupProductConfigsFailure(error) {
  return {
    type: types.UPDATE_GROUP_PRODUCT_CONFIGS_FAILURE,
    payload: error
  }
}

export function updateGroupProductConfigsSuccess(response) {
  return {
    type: types.UPDATE_GROUP_PRODUCT_CONFIGS_SUCCESS,
    payload: response
  }
}

export function resetUpdateGroupProductConfigsSuccess() {
  return {
    type: types.RESET_UPDATE_GROUP_PRODUCT_CONFIGS_SUCCESS
  }
}

export function resetUpdateGroupProductConfigsError(error) {
  return {
    type: types.RESET_UPDATE_GROUP_PRODUCT_CONFIGS_ERROR
  }
}

// add GROUP_PRODUCT_CONFIGS
export function addGroupProductConfigsRequest(payload) {
  return {
    type: types.ADD_GROUP_PRODUCT_CONFIGS_REQUEST,
    payload
  }
}

export function addGroupProductConfigsFailure(error) {
  return {
    type: types.ADD_GROUP_PRODUCT_CONFIGS_FAILURE,
    payload: error
  }
}

export function addGroupProductConfigsSuccess(response) {
  return {
    type: types.ADD_GROUP_PRODUCT_CONFIGS_SUCCESS,
    payload: response
  }
}

export function resetAddGroupProductConfigsSuccess() {
  return {
    type: types.RESET_ADD_GROUP_PRODUCT_CONFIGS_SUCCESS
  }
}

export function resetAddGroupProductConfigsError(error) {
  return {
    type: types.RESET_ADD_GROUP_PRODUCT_CONFIGS_ERROR
  }
}

export function getExtendedFamilyProductConfigsRequest(payload) {
  return {
    type: types.GET_EXTENDED_FAMILY_PRODUCT_CONFIGS_REQUEST,
    payload
  }
}

export function getExtendedFamilyProductConfigsFailure(error) {
  return {
    type: types.GET_EXTENDED_FAMILY_PRODUCT_CONFIGS_FAILURE,
    payload: error
  }
}

export function getExtendedFamilyProductConfigsSuccess(response) {
  return {
    type: types.GET_EXTENDED_FAMILY_PRODUCT_CONFIGS_SUCCESS,
    payload: response
  }
}

// update EXTENDED_FAMILY_PRODUCT_CONFIGS
export function updateExtendedFamilyProductConfigsRequest(payload) {
  return {
    type: types.UPDATE_EXTENDED_FAMILY_PRODUCT_CONFIGS_REQUEST,
    payload
  }
}

export function updateExtendedFamilyProductConfigsFailure(error) {
  return {
    type: types.UPDATE_EXTENDED_FAMILY_PRODUCT_CONFIGS_FAILURE,
    payload: error
  }
}

export function updateExtendedFamilyProductConfigsSuccess(response) {
  return {
    type: types.UPDATE_EXTENDED_FAMILY_PRODUCT_CONFIGS_SUCCESS,
    payload: response
  }
}

export function resetUpdateExtendedFamilyProductConfigsSuccess() {
  return {
    type: types.RESET_UPDATE_EXTENDED_FAMILY_PRODUCT_CONFIGS_SUCCESS
  }
}

export function resetUpdateExtendedFamilyProductConfigsError(error) {
  return {
    type: types.RESET_UPDATE_EXTENDED_FAMILY_PRODUCT_CONFIGS_ERROR
  }
}

// add EXTENDED_FAMILY_PRODUCT_CONFIGS
export function addExtendedFamilyProductConfigsRequest(payload) {
  return {
    type: types.ADD_EXTENDED_FAMILY_PRODUCT_CONFIGS_REQUEST,
    payload
  }
}

export function addExtendedFamilyProductConfigsFailure(error) {
  return {
    type: types.ADD_EXTENDED_FAMILY_PRODUCT_CONFIGS_FAILURE,
    payload: error
  }
}

export function addExtendedFamilyProductConfigsSuccess(response) {
  return {
    type: types.ADD_EXTENDED_FAMILY_PRODUCT_CONFIGS_SUCCESS,
    payload: response
  }
}

export function resetAddExtendedFamilyProductConfigsSuccess() {
  return {
    type: types.RESET_ADD_EXTENDED_FAMILY_PRODUCT_CONFIGS_SUCCESS
  }
}

export function resetAddExtendedFamilyProductConfigsError(error) {
  return {
    type: types.RESET_ADD_EXTENDED_FAMILY_PRODUCT_CONFIGS_ERROR
  }
}

// premium configs

// PREMIUMS
export function createPremiumConfigRequest(payload) {
  return {
    type: types.CREATE_PREMIUM_CONFIG_REQUEST,
    payload
  }
}

export function createPremiumConfigFailure(error) {
  return {
    type: types.CREATE_PREMIUM_CONFIG_FAILURE,
    payload: error
  }
}

export function createPremiumConfigSuccess(response) {
  return {
    type: types.CREATE_PREMIUM_CONFIG_SUCCESS,
    payload: response
  }
}

export function resetCreatePremiumConfigSuccess(error) {
  return {
    type: types.RESET_CREATE_PREMIUM_CONFIG_SUCCESS
  }
}

export function resetCreatePremiumConfigError(error) {
  return {
    type: types.RESET_CREATE_PREMIUM_CONFIG_ERROR
  }
}

// addons config

export function createaddOnsConfigRequest(payload) {
  return {
    type: types.CREATE_ADDON_CONFIG_REQUEST,
    payload
  }
}

export function createAddOnConfigFailure(error) {
  return {
    type: types.CREATE_ADDON_CONFIG_FAILURE,
    payload: error
  }
}

export function createAddOnConfigSuccess(response) {
  return {
    type: types.CREATE_ADDON_CONFIG_SUCCESS,
    payload: response
  }
}

export function resetCreateAddOnConfigSuccess(error) {
  return {
    type: types.RESET_CREATE_ADDON_CONFIG_SUCCESS
  }
}

export function resetCreateAddOnConfigError(error) {
  return {
    type: types.RESET_CREATE_ADDON_CONFIG_ERROR
  }
}

// end of addons configs
export function hardDeletePremiumConfigRequest(payload) {
  return {
    type: types.HARD_DELETE_PREMIUM_CONFIG_REQUEST,
    payload
  }
}

export function hardDeletePremiumConfigFailure(error) {
  return {
    type: types.HARD_DELETE_PREMIUM_CONFIG_FAILURE,
    payload: error
  }
}

export function hardDeletePremiumConfigSuccess(response) {
  return {
    type: types.HARD_DELETE_PREMIUM_CONFIG_SUCCESS,
    payload: response
  }
}

export function resetHardDeletePremiumConfigSuccess(error) {
  return {
    type: types.RESET_HARD_DELETE_PREMIUM_CONFIG_SUCCESS
  }
}

export function resetHardDeletePremiumConfigError(error) {
  return {
    type: types.RESET_HARD_DELETE_PREMIUM_CONFIG_ERROR
  }
}

export function editPremiumConfigRequest(payload) {
  return {
    type: types.EDIT_PREMIUM_CONFIG_REQUEST,
    payload
  }
}

export function editPremiumConfigFailure(error) {
  return {
    type: types.EDIT_PREMIUM_CONFIG_FAILURE,
    payload: error
  }
}

export function editPremiumConfigSuccess(response) {
  return {
    type: types.EDIT_PREMIUM_CONFIG_SUCCESS,
    payload: response
  }
}

export function resetEditPremiumConfigSuccess(error) {
  return {
    type: types.RESET_EDIT_PREMIUM_CONFIG_SUCCESS
  }
}

export function resetEditPremiumConfigError(error) {
  return {
    type: types.RESET_EDIT_PREMIUM_CONFIG_ERROR
  }
}

export function setPremiumConfigToEdit(response) {
  return {
    type: types.SET_PREMIUM_CONFIG_TO_EDIT,
    payload: response
  }
}

export function setPremiumConfigToDelete(response) {
  return {
    type: types.SET_PREMIUM_CONFIG_TO_DELETE,
    payload: response
  }
}

export function resetPremiumConfigToEdit(response) {
  return {
    type: types.RESET_PREMIUM_CONFIG_TO_EDIT
  }
}

export function resetPremiumConfigToDelete(response) {
  return {
    type: types.RESET_PREMIUM_CONFIG_TO_DELETE
  }
}

// GET GROUP_PRODUCT_CONFIGS
export function getPremiumConfigsRequest(payload) {
  return {
    type: types.GET_PREMIUM_CONFIGS_REQUEST,
    payload
  }
}

export function getPremiumConfigsFailure(error) {
  return {
    type: types.GET_PREMIUM_CONFIGS_FAILURE,
    payload: error
  }
}

export function getPremiumConfigsSuccess(response) {
  return {
    type: types.GET_PREMIUM_CONFIGS_SUCCESS,
    payload: response
  }
}

export function createProductPackageRequest(payload) {
  console.log('Action Payload for createProductPackageRequest:', payload)
  return {
    type: types.CREATE_PRODUCT_PACKAGE_REQUEST,
    payload
  }
}

export function createProductPackageFailure(error) {
  return {
    type: types.CREATE_PRODUCT_PACKAGE_FAILURE,
    payload: error
  }
}

export function createProductPackageSuccess(response) {
  return {
    type: types.CREATE_PRODUCT_PACKAGE_SUCCESS,
    payload: response
  }
}

export function resetCreateProductPackageSuccess() {
  return {
    type: types.RESET_CREATE_PRODUCT_PACKAGE_SUCCESS
  }
}

export function resetCreateProductPackageError() {
  return {
    type: types.RESET_CREATE_PRODUCT_PACKAGE_ERROR
  }
}

export function deleteProductPackageRequest(payload) {
  return {
    type: types.DELETE_PRODUCT_PACKAGE_REQUEST,
    payload
  }
}

export function deleteProductPackageFailure(error) {
  return {
    type: types.DELETE_PRODUCT_PACKAGE_FAILURE,
    payload: error
  }
}

export function deleteProductPackageSuccess(response) {
  return {
    type: types.DELETE_PRODUCT_PACKAGE_SUCCESS,
    payload: response
  }
}

export function resetDeleteProductPackageSuccess() {
  return {
    type: types.RESET_DELETE_PRODUCT_PACKAGE_SUCCESS
  }
}

export function resetDeleteProductPackageError() {
  return {
    type: types.RESET_DELETE_PRODUCT_PACKAGE_ERROR
  }
}

export function updateProductPackageRequest(payload) {
  return {
    type: types.UPDATE_PRODUCT_PACKAGE_REQUEST,
    payload
  }
}

export function updateProductPackageFailure(error) {
  return {
    type: types.UPDATE_PRODUCT_PACKAGE_FAILURE,
    payload: error
  }
}

export function updateProductPackageSuccess(response) {
  return {
    type: types.UPDATE_PRODUCT_PACKAGE_SUCCESS,
    payload: response
  }
}

export function resetUpdateProductPackageSuccess() {
  return {
    type: types.RESET_UPDATE_PRODUCT_PACKAGE_SUCCESS
  }
}

export function resetUpdateProductPackageError() {
  return {
    type: types.RESET_UPDATE_PRODUCT_PACKAGE_ERROR
  }
}

export function getProductPackagesRequest(payload) {
  return {
    type: types.GET_PRODUCT_PACKAGES_REQUEST,
    payload
  }
}

export function getProductPackagesFailure(error) {
  return {
    type: types.GET_PRODUCT_PACKAGES_FAILURE,
    payload: error
  }
}

export function getProductPackagesSuccess(response) {
  return {
    type: types.GET_PRODUCT_PACKAGES_SUCCESS,
    payload: response
  }
}

export function resetGetProductPackagesSuccess() {
  return {
    type: types.RESET_GET_PRODUCT_PACKAGES_SUCCESS
  }
}

export function resetGetProductPackagesError() {
  return {
    type: types.RESET_GET_PRODUCT_PACKAGES_ERROR
  }
}

export function getProductPackageBenefitsRequest(payload) {
  return {
    type: types.GET_PRODUCT_PACKAGE_BENEFITS_REQUEST,
    payload
  }
}

export function getProductPackageBenefitsFailure(error) {
  return {
    type: types.GET_PRODUCT_PACKAGE_BENEFITS_FAILURE,
    payload: error
  }
}

export function getProductPackageBenefitsSuccess(response) {
  return {
    type: types.GET_PRODUCT_PACKAGE_BENEFITS_SUCCESS,
    payload: response
  }
}

export function resetGetProductPackageBenefitsSuccess() {
  return {
    type: types.RESET_PRODUCT_PACKAGE_BENEFITS_SUCCESS
  }
}

export function resetGetProductPackageBenefitsError() {
  return {
    type: types.RESET_PRODUCT_PACKAGE_BENEFITS_ERROR
  }
}

export function createProductPackageBenefitRequest(payload) {
  return {
    type: types.CREATE_PRODUCT_PACKAGE_BENEFITS_REQUEST,
    payload
  }
}

export function createProductPackageBenefitFailure(error) {
  return {
    type: types.CREATE_PRODUCT_PACKAGE_BENEFITS_FAILURE,
    payload: error
  }
}

export function createProductPackageBenefitSuccess(response) {
  return {
    type: types.CREATE_PRODUCT_PACKAGE_BENEFITS_SUCCESS,
    payload: response
  }
}

export function resetCreateProductPackageBenefitSuccess() {
  return {
    type: types.RESET_PRODUCT_PACKAGE_BENEFITS_SUCCESS
  }
}

export function resetCreateProductPackageBenefitError() {
  return {
    type: types.RESET_PRODUCT_PACKAGE_BENEFITS_ERROR
  }
}

export function updateProductPackageBenefitRequest(payload) {
  return {
    type: types.UPDATE_PRODUCT_PACKAGE_BENEFITS_REQUEST,
    payload
  }
}

export function updateProductPackageBenefitFailure(error) {
  return {
    type: types.UPDATE_PRODUCT_PACKAGE_BENEFITS_FAILURE,
    payload: error
  }
}

export function updateProductPackageBenefitSuccess(response) {
  return {
    type: types.UPDATE_PRODUCT_PACKAGE_BENEFITS_SUCCESS,
    payload: response
  }
}

export function resetUpdateProductPackageBenefitSuccess() {
  return {
    type: types.RESET_PRODUCT_PACKAGE_BENEFITS_SUCCESS
  }
}

export function resetUpdateProductPackageBenefitError() {
  return {
    type: types.RESET_PRODUCT_PACKAGE_BENEFITS_ERROR
  }
}

export function deleteProductPackageBenefitRequest(payload) {
  return {
    type: types.DELETE_PRODUCT_PACKAGE_BENEFITS_REQUEST,
    payload
  }
}

export function deleteProductPackageBenefitFailure(error) {
  return {
    type: types.DELETE_PRODUCT_PACKAGE_BENEFITS_FAILURE,
    payload: error
  }
}

export function deleteProductPackageBenefitSuccess(response) {
  return {
    type: types.DELETE_PRODUCT_PACKAGE_BENEFITS_SUCCESS,
    payload: response
  }
}

export function resetDeleteProductPackageBenefitSuccess() {
  return {
    type: types.RESET_PRODUCT_PACKAGE_BENEFITS_SUCCESS
  }
}

export function resetDeleteProductPackageBenefitError() {
  return {
    type: types.RESET_PRODUCT_PACKAGE_BENEFITS_ERROR
  }
}

export function getProductAddonsRequest(payload) {
  return {
    type: types.GET_PRODUCT_ADDONS_REQUEST,
    payload
  }
}

export function getProductAddonsFailure(error) {
  return {
    type: types.GET_PRODUCT_ADDONS_FAILURE,
    payload: error
  }
}

export function getProductAddonsSuccess(response) {
  return {
    type: types.GET_PRODUCT_ADDONS_SUCCESS,
    payload: response
  }
}

export function resetGetProductAddonsSuccess() {
  return {
    type: types.RESET_GET_PRODUCT_ADDONS_SUCCESS
  }
}

export function resetGetProductAddonsError() {
  return {
    type: types.RESET_GET_PRODUCT_ADDONS_ERROR
  }
}
export function createProductAddonRequest(payload) {
  return {
    type: types.CREATE_PRODUCT_ADDON_REQUEST,
    payload
  }
}

export function createProductAddonFailure(error) {
  return {
    type: types.CREATE_PRODUCT_ADDON_FAILURE,
    payload: error
  }
}

export function createProductAddonSuccess(response) {
  return {
    type: types.CREATE_PRODUCT_ADDON_SUCCESS,
    payload: response
  }
}

export function resetCreateProductAddonSuccess() {
  return {
    type: types.RESET_CREATE_PRODUCT_ADDON_SUCCESS
  }
}

export function resetCreateProductAddonError() {
  return {
    type: types.RESET_CREATE_PRODUCT_ADDON_ERROR
  }
}

export function deleteProductAddonRequest(payload) {
  return {
    type: types.DELETE_PRODUCT_ADDON_REQUEST,
    payload
  }
}

export function deleteProductAddonFailure(error) {
  return {
    type: types.DELETE_PRODUCT_ADDON_FAILURE,
    payload: error
  }
}

export function deleteProductAddonSuccess(response) {
  return {
    type: types.DELETE_PRODUCT_ADDON_SUCCESS,
    payload: response
  }
}

export function resetDeleteProductAddonSuccess() {
  return {
    type: types.RESET_DELETE_PRODUCT_ADDON_SUCCESS
  }
}

export function resetDeleteProductAddonError() {
  return {
    type: types.RESET_DELETE_PRODUCT_ADDON_ERROR
  }
}
export function updateProductAddonRequest(payload) {
  return {
    type: types.UPDATE_PRODUCT_ADDON_REQUEST,
    payload
  }
}

export function updateProductAddonFailure(error) {
  return {
    type: types.UPDATE_PRODUCT_ADDON_FAILURE,
    payload: error
  }
}

export function updateProductAddonSuccess(response) {
  return {
    type: types.UPDATE_PRODUCT_ADDON_SUCCESS,
    payload: response
  }
}

export function resetUpdateProductAddonSuccess() {
  return {
    type: types.RESET_UPDATE_PRODUCT_ADDON_SUCCESS
  }
}

export function resetUpdateProductAddonError() {
  return {
    type: types.RESET_UPDATE_PRODUCT_ADDON_ERROR
  }
}

export function createCashBackConfigRequest(payload) {
  return {
    type: types.CREATE_CASHBACK_CONFIG_REQUEST,
    payload
  }
}

export function createCashBackConfigFailure(error) {
  return {
    type: types.CREATE_CASHBACK_CONFIG_FAILURE,
    payload: error
  }
}

export function createCashBackConfigSuccess(response) {
  return {
    type: types.CREATE_CASHBACK_CONFIG_SUCCESS,
    payload: response
  }
}

export function resetCreateCashBackConfigSuccess() {
  return {
    type: types.RESET_CASHBACK_CONFIG_SUCCESS
  }
}

export function resetCreateCashBackConfigError() {
  return {
    type: types.RESET_CASHBACK_CONFIG_ERROR
  }
}

export function deleteCashBackConfigRequest(payload) {
  return {
    type: types.DELETE_CASHBACK_CONFIG_REQUEST,
    payload
  }
}

export function deleteCashBackConfigFailure(error) {
  return {
    type: types.DELETE_CASHBACK_CONFIG_FAILURE,
    payload: error
  }
}

export function deleteCashBackConfigSuccess(response) {
  return {
    type: types.DELETE_CASHBACK_CONFIG_SUCCESS,
    payload: response
  }
}

export function resetDeleteCashBackConfigSuccess() {
  return {
    type: types.RESET_CASHBACK_CONFIG_SUCCESS
  }
}

export function resetDeleteCashBackConfigError() {
  return {
    type: types.RESET_CASHBACK_CONFIG_ERROR
  }
}

export function updateCashBackConfigRequest(payload) {
  return {
    type: types.UPDATE_CASHBACK_CONFIG_REQUEST,
    payload
  }
}

export function updateCashBackConfigFailure(error) {
  return {
    type: types.UPDATE_CASHBACK_CONFIG_FAILURE,
    payload: error
  }
}

export function updateCashBackConfigSuccess(response) {
  return {
    type: types.UPDATE_CASHBACK_CONFIG_SUCCESS,
    payload: response
  }
}

export function resetUpdateCashBackConfigSuccess() {
  return {
    type: types.RESET_CASHBACK_CONFIG_SUCCESS
  }
}

export function resetUpdateCashBackConfigError() {
  return {
    type: types.RESET_CASHBACK_CONFIG_ERROR
  }
}

export function getCashBackConfigsRequest(payload) {
  return {
    type: types.GET_CASHBACK_CONFIGS_REQUEST,
    payload
  }
}

export function getCashBackConfigsFailure(error) {
  return {
    type: types.GET_CASHBACK_CONFIGS_FAILURE,
    payload: error
  }
}

export function getCashBackConfigsSuccess(response) {
  return {
    type: types.GET_CASHBACK_CONFIGS_SUCCESS,
    payload: response
  }
}

export function resetGetCashBackConfigsSuccess() {
  return {
    type: types.RESET_CASHBACK_CONFIG_SUCCESS
  }
}

export function resetGetCashBackConfigsError() {
  return {
    type: types.RESET_CASHBACK_CONFIG_ERROR
  }
}

export function createAgeValidationRuleRequest(payload) {
  return {
    type: types.CREATE_AGE_VALIDATION_RULE_REQUEST,
    payload
  }
}

export function createAgeValidationRuleFailure(error) {
  return {
    type: types.CREATE_AGE_VALIDATION_RULE_FAILURE,
    payload: error
  }
}

export function createAgeValidationRuleSuccess(response) {
  return {
    type: types.CREATE_AGE_VALIDATION_RULE_SUCCESS,
    payload: response
  }
}

export function resetCreateAgeValidationRuleSuccess() {
  return {
    type: types.RESET_AGE_VALIDATION_RULE_SUCCESS
  }
}

export function resetCreateAgeValidationRuleError() {
  return {
    type: types.RESET_AGE_VALIDATION_RULE_ERROR
  }
}
export function getAgeValidationRulesRequest(payload) {
  return {
    type: types.GET_AGE_VALIDATION_RULES_REQUEST,
    payload
  }
}

export function getAgeValidationRulesFailure(error) {
  return {
    type: types.GET_AGE_VALIDATION_RULES_FAILURE,
    payload: error
  }
}
export function getAgeValidationRulesSuccess(response) {
  return {
    type: types.GET_AGE_VALIDATION_RULES_SUCCESS,
    payload: response
  }
}

export function resetGetAgeValidationRulesSuccess() {
  return {
    type: types.RESET_AGE_VALIDATION_RULE_SUCCESS
  }
}

export function resetGetAgeValidationRulesError() {
  return {
    type: types.RESET_AGE_VALIDATION_RULE_ERROR
  }
}
export function deleteAgeValidationRuleRequest(payload) {
  return {
    type: types.DELETE_AGE_VALIDATION_RULE_REQUEST,
    payload
  }
}

export function deleteAgeValidationRuleFailure(error) {
  return {
    type: types.DELETE_AGE_VALIDATION_RULE_FAILURE,
    payload: error
  }
}
export function deleteAgeValidationRuleSuccess(response) {
  return {
    type: types.DELETE_AGE_VALIDATION_RULE_SUCCESS,
    payload: response
  }
}

export function resetDeleteAgeValidationRuleSuccess() {
  return {
    type: types.RESET_AGE_VALIDATION_RULE_SUCCESS
  }
}

export function resetDeleteAgeValidationRuleError() {
  return {
    type: types.RESET_AGE_VALIDATION_RULE_ERROR
  }
}

export function updateAgeValidationRuleRequest(payload) {
  return {
    type: types.UPDATE_AGE_VALIDATION_RULE_REQUEST,
    payload
  }
}

export function updateAgeValidationRuleFailure(error) {
  return {
    type: types.UPDATE_AGE_VALIDATION_RULE_FAILURE,
    payload: error
  }
}
export function updateAgeValidationRuleSuccess(response) {
  return {
    type: types.UPDATE_AGE_VALIDATION_RULE_SUCCESS,
    payload: response
  }
}

export function resetUpdateAgeValidationRuleSuccess() {
  return {
    type: types.RESET_AGE_VALIDATION_RULE_SUCCESS
  }
}

export function resetUpdateAgeValidationRuleError() {
  return {
    type: types.RESET_AGE_VALIDATION_RULE_ERROR
  }
}

export function createProductAutoRenewalConfigRequest(payload) {
  return {
    type: types.CREATE_PRODUCT_AUTO_RENEWAL_CONFIG_REQUEST,
    payload
  }
}

export function createProductAutoRenewalConfigFailure(error) {
  return {
    type: types.CREATE_PRODUCT_AUTO_RENEWAL_CONFIG_FAILURE,
    payload: error
  }
}

export function createProductAutoRenewalConfigSuccess(response) {
  return {
    type: types.CREATE_PRODUCT_AUTO_RENEWAL_CONFIG_SUCCESS,
    payload: response
  }
}

export function deleteProductAutoRenewalConfigRequest(payload) {
  return {
    type: types.DELETE_PRODUCT_AUTO_RENEWAL_CONFIG_REQUEST,
    payload
  }
}

export function deleteProductAutoRenewalConfigFailure(error) {
  return {
    type: types.DELETE_PRODUCT_AUTO_RENEWAL_CONFIG_FAILURE,
    payload: error
  }
}

export function deleteProductAutoRenewalConfigSuccess(response) {
  return {
    type: types.DELETE_PRODUCT_AUTO_RENEWAL_CONFIG_SUCCESS,
    payload: response
  }
}

export function resetProductAutoRenewalConfigSuccess() {
  return {
    type: types.RESET_PRODUCT_AUTO_RENEWAL_CONFIG_SUCCESS
  }
}

export function resetProductAutoRenewalConfigError() {
  return {
    type: types.RESET_PRODUCT_AUTO_RENEWAL_CONFIG_ERROR
  }
}

export function updateProductAutoRenewalConfigRequest(payload) {
  return {
    type: types.UPDATE_PRODUCT_AUTO_RENEWAL_CONFIG_REQUEST,
    payload
  }
}

export function updateProductAutoRenewalConfigFailure(error) {
  return {
    type: types.UPDATE_PRODUCT_AUTO_RENEWAL_CONFIG_FAILURE,
    payload: error
  }
}

export function updateProductAutoRenewalConfigSuccess(response) {
  return {
    type: types.UPDATE_PRODUCT_AUTO_RENEWAL_CONFIG_SUCCESS,
    payload: response
  }
}

export function getProductAutoRenewalConfigRequest(payload) {
  return {
    type: types.GET_PRODUCT_AUTO_RENEWAL_CONFIG_REQUEST,
    payload
  }
}

export function getProductAutoRenewalConfigFailure(error) {
  return {
    type: types.GET_PRODUCT_AUTO_RENEWAL_CONFIG_FAILURE,
    payload: error
  }
}

export function getProductAutoRenewalConfigSuccess(response) {
  return {
    type: types.GET_PRODUCT_AUTO_RENEWAL_CONFIG_SUCCESS,
    payload: response
  }
}

export function resetGetProductAutoRenewalConfigSuccess() {
  return {
    type: types.RESET_PRODUCT_AUTO_RENEWAL_CONFIG_SUCCESS
  }
}

export function resetGetProductAutoRenewalConfigError() {
  return {
    type: types.RESET_PRODUCT_AUTO_RENEWAL_CONFIG_ERROR
  }
}

// AI Drafting actions
export function draftFileSelect(file) {
  return { type: types.DRAFT_FILE_SELECT, payload: file }
}

export function draftFileClear() {
  return { type: types.DRAFT_FILE_CLEAR }
}

export function uploadDocumentRequest(file) {
  return { type: types.UPLOAD_DOCUMENT_REQUEST, payload: file }
}

export function uploadDocumentSuccess(jobId) {
  return { type: types.UPLOAD_DOCUMENT_SUCCESS, payload: jobId }
}

export function uploadDocumentFailure(error) {
  return { type: types.UPLOAD_DOCUMENT_FAILURE, payload: error }
}

export function pollDraftJobRequest(jobId) {
  return { type: types.POLL_DRAFT_JOB_REQUEST, payload: jobId }
}

export function pollDraftJobSuccess(draftResult) {
  return { type: types.POLL_DRAFT_JOB_SUCCESS, payload: draftResult }
}

export function pollDraftJobProcessing() {
  return { type: types.POLL_DRAFT_JOB_PROCESSING }
}

export function pollDraftJobFailure(error) {
  return { type: types.POLL_DRAFT_JOB_FAILURE, payload: error }
}

export function resetDraftState() {
  return { type: types.RESET_DRAFT_STATE }
}

export function fetchPartnerDraftsRequest() {
  return { type: types.FETCH_PARTNER_DRAFTS_REQUEST }
}

export function fetchPartnerDraftsSuccess(drafts) {
  return { type: types.FETCH_PARTNER_DRAFTS_SUCCESS, payload: drafts }
}

export function fetchPartnerDraftsFailure(error) {
  return { type: types.FETCH_PARTNER_DRAFTS_FAILURE, payload: error }
}

export function reviewDraftRequest(jobId) {
  return { type: types.REVIEW_DRAFT_REQUEST, payload: jobId }
}

export function reviewDraftSuccess(detail) {
  return { type: types.REVIEW_DRAFT_SUCCESS, payload: detail }
}

export function reviewDraftFailure(error) {
  return { type: types.REVIEW_DRAFT_FAILURE, payload: error }
}

export function clearReviewDraft() {
  return { type: types.CLEAR_REVIEW_DRAFT }
}

export function importDraftProductRequest(jobId) {
  return { type: types.IMPORT_DRAFT_PRODUCT_REQUEST, payload: jobId }
}

export function importDraftProductSuccess(product) {
  return { type: types.IMPORT_DRAFT_PRODUCT_SUCCESS, payload: product }
}

export function importDraftProductFailure(error) {
  return { type: types.IMPORT_DRAFT_PRODUCT_FAILURE, payload: error }
}

export function evaluateProductQuoteRequest(payload) {
  return { type: types.EVALUATE_PRODUCT_QUOTE_REQUEST, payload }
}
export function evaluateProductQuoteSuccess(response) {
  return { type: types.EVALUATE_PRODUCT_QUOTE_SUCCESS, payload: response }
}
export function evaluateProductQuoteFailure(error) {
  return { type: types.EVALUATE_PRODUCT_QUOTE_FAILURE, payload: error }
}
export function compareQuotationsRequest(payload) {
  return { type: types.COMPARE_QUOTATIONS_REQUEST, payload }
}
export function compareQuotationsSuccess(response) {
  return { type: types.COMPARE_QUOTATIONS_SUCCESS, payload: response }
}
export function compareQuotationsFailure(error) {
  return { type: types.COMPARE_QUOTATIONS_FAILURE, payload: error }
}
export function resetQuotationResults() {
  return { type: types.RESET_QUOTATION_RESULTS }
}

// Rating Nodes
export function getProductRatingNodesRequest(payload) {
  return { type: types.GET_PRODUCT_RATING_NODES_REQUEST, payload }
}
export function getProductRatingNodesFailure(error) {
  return { type: types.GET_PRODUCT_RATING_NODES_FAILURE, payload: error }
}
export function getProductRatingNodesSuccess(response) {
  return { type: types.GET_PRODUCT_RATING_NODES_SUCCESS, payload: response }
}
export function createProductRatingNodeRequest(payload) {
  return { type: types.CREATE_PRODUCT_RATING_NODE_REQUEST, payload }
}
export function createProductRatingNodeFailure(error) {
  return { type: types.CREATE_PRODUCT_RATING_NODE_FAILURE, payload: error }
}
export function createProductRatingNodeSuccess(response) {
  return { type: types.CREATE_PRODUCT_RATING_NODE_SUCCESS, payload: response }
}
export function updateProductRatingNodeRequest(payload) {
  return { type: types.UPDATE_PRODUCT_RATING_NODE_REQUEST, payload }
}
export function updateProductRatingNodeFailure(error) {
  return { type: types.UPDATE_PRODUCT_RATING_NODE_FAILURE, payload: error }
}
export function updateProductRatingNodeSuccess(response) {
  return { type: types.UPDATE_PRODUCT_RATING_NODE_SUCCESS, payload: response }
}
export function deleteProductRatingNodeRequest(payload) {
  return { type: types.DELETE_PRODUCT_RATING_NODE_REQUEST, payload }
}
export function deleteProductRatingNodeFailure(error) {
  return { type: types.DELETE_PRODUCT_RATING_NODE_FAILURE, payload: error }
}
export function deleteProductRatingNodeSuccess(response) {
  return { type: types.DELETE_PRODUCT_RATING_NODE_SUCCESS, payload: response }
}
export function resetRatingNodeSuccess() {
  return { type: types.RESET_RATING_NODE_SUCCESS }
}
export function resetRatingNodeError() {
  return { type: types.RESET_RATING_NODE_ERROR }
}

// ── Rating Tables ────────────────────────────────────────────────────────────
export function getRatingTablesRequest(payload) {
  return { type: types.GET_RATING_TABLES_REQUEST, payload }
}
export function getRatingTablesSuccess(response) {
  return { type: types.GET_RATING_TABLES_SUCCESS, payload: response }
}
export function getRatingTablesFailure(error) {
  return { type: types.GET_RATING_TABLES_FAILURE, payload: error }
}
// payload: { guid, action: 'activate' | 'deactivate' | 'delete' }
export function ratingTableActionRequest(payload) {
  return { type: types.RATING_TABLE_ACTION_REQUEST, payload }
}
export function ratingTableActionSuccess(response) {
  return { type: types.RATING_TABLE_ACTION_SUCCESS, payload: response }
}
export function ratingTableActionFailure(error) {
  return { type: types.RATING_TABLE_ACTION_FAILURE, payload: error }
}
// payload: { guid?, version?, table }  — guid present → update, absent → create
export function saveRatingTableRequest(payload) {
  return { type: types.SAVE_RATING_TABLE_REQUEST, payload }
}
export function saveRatingTableSuccess(response) {
  return { type: types.SAVE_RATING_TABLE_SUCCESS, payload: response }
}
export function saveRatingTableFailure(error) {
  return { type: types.SAVE_RATING_TABLE_FAILURE, payload: error }
}
export function resetRatingTableFeedback() {
  return { type: types.RESET_RATING_TABLE_FEEDBACK }
}

// ── Benefit pricing wizard ───────────────────────────────────────────────────
// payload: { product_guid, package_guid, targets, benefitPayload } — see
// saga.es6.js's createBenefitRatingChainRequestWatcher for the exact shape.
// `targets` entries may already carry a `tableGuid`/`nodeGuid` from a prior
// failed attempt (see createBenefitRatingChainProgress) — the watcher skips
// re-creating anything a target already has, so a retry only redoes the
// stage(s) that actually failed.
export function createBenefitRatingChainRequest(payload) {
  return { type: types.CREATE_BENEFIT_RATING_CHAIN_REQUEST, payload }
}
// payload: { targets } — the accumulated per-target progress at the point of
// failure, handed back so the component can merge it into its retry payload.
export function createBenefitRatingChainProgress(payload) {
  return { type: types.CREATE_BENEFIT_RATING_CHAIN_PROGRESS, payload }
}
export function createBenefitRatingChainSuccess(response) {
  return { type: types.CREATE_BENEFIT_RATING_CHAIN_SUCCESS, payload: response }
}
export function createBenefitRatingChainFailure(error) {
  return { type: types.CREATE_BENEFIT_RATING_CHAIN_FAILURE, payload: error }
}
export function resetBenefitRatingChainState() {
  return { type: types.RESET_BENEFIT_RATING_CHAIN_STATE }
}

// payload: { product_guid, package_guid, benefit_guid, createTargets,
//            updateTargets, benefitPayload } — see
// saga.es6.js's updateBenefitRatingChainRequestWatcher (§9.3).
export function updateBenefitRatingChainRequest(payload) {
  return { type: types.UPDATE_BENEFIT_RATING_CHAIN_REQUEST, payload }
}
export function updateBenefitRatingChainProgress(payload) {
  return { type: types.UPDATE_BENEFIT_RATING_CHAIN_PROGRESS, payload }
}
export function updateBenefitRatingChainSuccess(response) {
  return { type: types.UPDATE_BENEFIT_RATING_CHAIN_SUCCESS, payload: response }
}
export function updateBenefitRatingChainFailure(error) {
  return { type: types.UPDATE_BENEFIT_RATING_CHAIN_FAILURE, payload: error }
}
export function resetUpdateBenefitRatingChainState() {
  return { type: types.RESET_UPDATE_BENEFIT_RATING_CHAIN_STATE }
}

// ── Rating Bulk Import ───────────────────────────────────────────────────────
// payload: productGuid
export function downloadRatingTemplateRequest(payload) {
  return { type: types.DOWNLOAD_RATING_TEMPLATE_REQUEST, payload }
}
export function downloadRatingTemplateSuccess() {
  return { type: types.DOWNLOAD_RATING_TEMPLATE_SUCCESS }
}
export function downloadRatingTemplateFailure(error) {
  return { type: types.DOWNLOAD_RATING_TEMPLATE_FAILURE, payload: error }
}
// payload: { productGuid, file } — the File is chosen client-side and re-used
// for both validate and import; productGuid is stamped onto state so a
// remount (e.g. tab switch away and back) can tell "same product" apart from
// "different product" without resetting on every mount.
export function selectRatingWorkbook(payload) {
  return { type: types.SELECT_RATING_WORKBOOK, payload }
}
// payload: { productGuid, file }
export function validateRatingWorkbookRequest(payload) {
  return { type: types.VALIDATE_RATING_WORKBOOK_REQUEST, payload }
}
export function validateRatingWorkbookSuccess(response) {
  return { type: types.VALIDATE_RATING_WORKBOOK_SUCCESS, payload: response }
}
export function validateRatingWorkbookFailure(error) {
  return { type: types.VALIDATE_RATING_WORKBOOK_FAILURE, payload: error }
}
// payload: { productGuid, file }
export function importRatingWorkbookRequest(payload) {
  return { type: types.IMPORT_RATING_WORKBOOK_REQUEST, payload }
}
export function importRatingWorkbookSuccess(response) {
  return { type: types.IMPORT_RATING_WORKBOOK_SUCCESS, payload: response }
}
export function importRatingWorkbookFailure(error) {
  return { type: types.IMPORT_RATING_WORKBOOK_FAILURE, payload: error }
}
export function resetRatingImport() {
  return { type: types.RESET_RATING_IMPORT }
}

// ── Rating Snapshots ─────────────────────────────────────────────────────────
export function getRatingSnapshotsRequest(payload) {
  return { type: types.GET_RATING_SNAPSHOTS_REQUEST, payload }
}
export function getRatingSnapshotsSuccess(response) {
  return { type: types.GET_RATING_SNAPSHOTS_SUCCESS, payload: response }
}
export function getRatingSnapshotsFailure(error) {
  return { type: types.GET_RATING_SNAPSHOTS_FAILURE, payload: error }
}

// ── Change Requests (partner-wide) ───────────────────────────────────────────
export function getChangeRequestsRequest(payload) {
  return { type: types.GET_CHANGE_REQUESTS_REQUEST, payload }
}
export function getChangeRequestsSuccess(response) {
  return { type: types.GET_CHANGE_REQUESTS_SUCCESS, payload: response }
}
export function getChangeRequestsFailure(error) {
  return { type: types.GET_CHANGE_REQUESTS_FAILURE, payload: error }
}
// payload: { guid, decision: 'approve' | 'reject', reason? }
export function resolveChangeRequestRequest(payload) {
  return { type: types.RESOLVE_CHANGE_REQUEST_REQUEST, payload }
}
export function resolveChangeRequestSuccess(response) {
  return { type: types.RESOLVE_CHANGE_REQUEST_SUCCESS, payload: response }
}
export function resolveChangeRequestFailure(error) {
  return { type: types.RESOLVE_CHANGE_REQUEST_FAILURE, payload: error }
}
export function resetChangeRequestFeedback() {
  return { type: types.RESET_CHANGE_REQUEST_FEEDBACK }
}
